import React, { CSSProperties } from 'react'
import Text from '@embracesbs/component-text'

interface SectionHeaderProps {
  title: string
  sticky?: boolean
}

const wrapStyle: CSSProperties = {
  width: '100%',
  boxSizing: 'border-box',
  padding: '0 2px 6px',
  marginBottom: '12px',
  borderBottom: '2px solid var(--tma-accent)'
}

const stickyStyle: CSSProperties = {
  position: 'sticky',
  top: 0,
  zIndex: 2,
  background: 'var(--tma-page-bg)',
  paddingTop: '6px'
}

// Uses the same design-system heading style ('h6') as the "Subscription Properties"
// heading in the details panel, so the section labels match the rest of the app.
const SectionHeader: React.FC<SectionHeaderProps> = ({ title, sticky }) => {
  return (
    <div style={sticky ? { ...wrapStyle, ...stickyStyle } : wrapStyle}>
      <Text textStyle='h6' content={title} style={{ color: 'var(--tma-text-muted)' }} />
    </div>
  )
}

export default SectionHeader
